var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { role: "main" } },
    [
      _c("h1", { attrs: { tabindex: "-1" } }, [
        _vm._v(_vm._s(_vm.$t("UserManagement.Title")))
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.$t("UserManagement.Description")) }
      }),
      _vm._v(" "),
      _c("change-email-view", { staticClass: "mt-5" }),
      _vm._v(" "),
      _c("invite-basic-user-view", { staticClass: "mt-5" }),
      _vm._v(" "),
      _c("admin-management-view", { staticClass: "mt-5" }),
      _vm._v(" "),
      _c("users-view", { staticClass: "mt-5 mb-5" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }